export default "__VITE_ASSET__BKS8ah55__"